var React = require( 'react' );
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var PureRenderMixin = require('react-addons-pure-render-mixin');
var DatePicker = require('./datePicker.jsx');
var FBLoginButtonWrapper = require('./fbLoginButtonWrapper.jsx');

var Register = createReactClass({
	mixins: [PureRenderMixin],

    getInitialState: function(){
        return {
            dob: '1/1/' + new Date().getFullYear(),
			gender: ''
        };
    },

    handleDateChange: function(month, day, year){
        this.setState({dob: month + '/' + day + '/' + year});
    },

	handleGenderChange: function(event){
		var selectEle = event.currentTarget;
		this.setState({gender: selectEle.options[selectEle.selectedIndex].value});
	},

	handleSubmit: function(event) {
		event.preventDefault()
	    var firstName = this.refs.firstName.value.trim();
		var lastName = this.refs.lastName.value.trim();
	    var email = this.refs.email.value.trim().toLowerCase();
	    var password = this.refs.password.value;
	    var dob = this.state.dob;
		var postalCode = this.refs.postalCode.value.trim();
	    this.props.signUp(firstName, lastName, email, password, this.state.gender, dob, postalCode, this.props.loginRedirectUrl, this.props.analyticsLabelSuffix);
	},

    handleClickTracking: function(event){
        var target = event.target;
        var label = target.innerText + (this.props.analyticsLabelSuffix ? ' ' + this.props.analyticsLabelSuffix : '');
        var action = 'Click';

        if(label === 'Complete Registration'){
            action = 'Submit';
            label = 'Email' + (this.props.analyticsLabelSuffix ? ' ' + this.props.analyticsLabelSuffix : '');
        }

        this.props.recordRegisterClick(action, label);
    },

    handleLoginEntryClick: function(event){
        event.preventDefault();
        this.handleClickTracking(event);
        this.props.clearRegError();
        this.props.showModal('MODAL_TYPE_LOGIN');
    },

    render: function(){
        var errorMsg = this.props.auth && Object.keys(this.props.auth.error).length > 0 && (this.props.auth.error.message ? this.props.auth.error.message : this.props.auth.error.toString());

		var date = new Date(this.state.dob);
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();

        return (
            <div className="special-form-box-wrapper">
                <div className="register-box special-form-box">
					<h1 className="hide-for-large">Sign Up</h1>
                    <div className="form">
                        {this.props.authFacebook &&
                            <FBLoginButtonWrapper
                                authFacebook={this.props.authFacebook}
                                loginRedirectUrl={this.props.loginRedirectUrl}
                                source={this.props.source}
                                label="Continue with Facebook"
                                clickTracking={this.props.recordRegisterClick} />
                        }
                        <form onSubmit={this.handleSubmit} noValidate autoComplete="off">
							<div className="input-field-wrapper">
								<div className="input-field">
									<label className="heading" htmlFor="firstName">First Name</label>
									<input type="text" name="firstName" id="firstName" ref="firstName" placeholder="John" required />
								</div>
								<div className="input-field">
									<label className="heading" htmlFor="lastName">Last Name</label>
									<input type="text" name="lastName" id="lastName" ref="lastName" placeholder="Smith" required />
								</div>
	                            <div className="input-field">
	                                <label className="heading" htmlFor="email">Email</label>
	                                <input type="email" name="email" id="email" ref="email" placeholder="john@example.com" required autoComplete="off" />
	                            </div>
	                            <div className="input-field">
	                                <label className="heading" htmlFor="password">Password</label>
	                                <input type="password" name="password" id="password" ref="password" required />
	                            </div>
							</div>

							<div className="input-field-wrapper">
								<div className="postalCode-input-field input-field">
	                                <label className="heading" htmlFor="postalCode">ZIP Code</label>
	                                <input type="text" name="postalCode" id="postalCode" ref="postalCode" placeholder="ZIP Code" required autoComplete="off" />
									<div className="tip">
										<span className="ion-ios-information-outline"></span>
										<p>Your location helps us find relevant clinical trials near you</p>
									</div>
	                            </div>
							</div>

							<div className={'gender-picker input-field-wrapper ' + this.state.gender}>
								<div className="input-field">
									<label className="heading" htmlFor="gender">Gender</label>
									<div className="select-container">
										<select name="gender" id="gender" ref="gender" value={this.state.gender} onChange={this.handleGenderChange}>
											<option value="">Select Your Gender</option>
											<option value="male">Male</option>
											<option value="female">Female</option>
										</select>
									</div>
								</div>
							</div>

							<p className="input-field-title">Birthdate</p>
							<DatePicker month={month} day={day} year={year} onDateChange={this.handleDateChange} />

							<div id="agree-to-terms">
                                <p>By continuing you are agreeing to the <br /><Link to="/terms" onClick={this.handleClickTracking}>Terms and Conditions</Link></p>
                            </div>

                            <button className="button success expanded" type="submit" onClick={this.handleClickTracking}>Complete Registration</button>
                            {errorMsg && <p className="error-msg">{errorMsg}</p>}
                            <p className="login-entry-wrapper show-for-reveal">Existing user? <Link to="/login" onClick={this.handleLoginEntryClick}>Login here</Link></p>
                        </form>
                    </div>
                </div>
                <div className="special-form-box-suffix">
                    <p className="text-center">Already have an Account? <Link to="/login" onClick={this.handleClickTracking}>Sign In</Link></p>
                </div>
            </div>
        )
    }
});

module.exports = Register;



// WEBPACK FOOTER //
// ./src/common/routes/components/registerBox.jsx